module.exports = __webpack_public_path__ + "images/baa370bb2ad3ee9bd7195f1a122b4bec.png";